module.exports = __webpack_public_path__ + "img/logo.69b27d11.png";